import { FC, PropsWithChildren } from 'react';
import { useRouter } from 'next/compat/router';
import { GlobalHeader } from '@belong/global-header';
import useAuthentication from '@belong/providers/authentication';
import { IHeaderMenu, IPageAlert } from '@belong/types';
import { getUrlPath, withBasePath } from '@belong/url-utils';

export interface IGlobalHeaderContainer {
  headerMenuContent: IHeaderMenu;
  pageAlert?: IPageAlert;
  showBackToTopTrigger: boolean;
  isNbnOrderCartReady?: boolean;
}

const GlobalHeaderContainer: FC<PropsWithChildren<IGlobalHeaderContainer>> = ({
  headerMenuContent,
  pageAlert,
  showBackToTopTrigger,
  isNbnOrderCartReady,
  children
}) => {
  const { isLoggedIn, userType } = useAuthentication();
  const router = useRouter();
  const asPath = router ? router.asPath : '';

  const currentUrl = withBasePath(getUrlPath(asPath));

  return (
    <GlobalHeader
      headerMenuContent={headerMenuContent}
      currentUrl={currentUrl}
      isLoggedIn={isLoggedIn}
      pageAlert={pageAlert}
      showBackToTopTrigger={showBackToTopTrigger}
      userType={userType}
      isNbnOrderCartReady={isNbnOrderCartReady}
    >
      {children}
    </GlobalHeader>
  );
};

GlobalHeaderContainer.displayName = 'GlobalHeaderContainer';

export default GlobalHeaderContainer;
